import { Screen } from "../components/Screen";
import { Footer } from "../components/Footer";
import { CSSProperties, useEffect, useState } from "react";
import { Font } from "../constants/fonts";
import { Colors } from "../constants/colors";

// Adicione aqui os caminhos das imagens
const IMAGE_PATHS = {
  mainImage: "integrante0.png",        // Imagem principal da equipe
};

const TEAM_MEMBERS = [
    {
        name: "Lélio Saunders",
        role: "Idealizador do ClikMob / Sócio-Fundador",
        image: "integrante1.png",
        paragraphs: [
            "Brasiliense, 48 anos, administrador e estudante de Gestão de Recursos Humanos, Lélio Saunders construiu sua trajetória profissional atuando nas áreas de administração, gestão de pessoas, administração condominial e desenvolvimento de projetos voltados ao atendimento da comunidade.",
            "Ao longo de sua carreira, sempre acreditou que a tecnologia e a boa gestão devem estar a serviço das pessoas. Essa visão o levou a desenvolver soluções baseadas na escuta, no diálogo e na busca constante por inovação com responsabilidade.",
            "Idealizador do ClikMob, acredita que a mobilidade urbana pode evoluir sem perder aquilo que mais importa: o respeito pelas pessoas. Seu propósito é aproximar tecnologia e humanização, valorizando os profissionais que fazem a cidade funcionar todos os dias e oferecendo aos passageiros uma experiência baseada em confiança, segurança e qualidade.",
            "Para Lélio, o ClikMob representa mais do que uma plataforma de mobilidade. É um projeto construído para fortalecer pessoas, incentivar parcerias e contribuir para uma mobilidade urbana mais justa, acessível e sustentável.",
        ],
    },
    {
        name: "Ederson Henrique Gallo",
        role: "Sócio-Fundador",
        image: "integrante2.png",
        paragraphs: [
            "Natural de Três Corações, Minas Gerais, Ederson Henrique Gallo reside em Brasília desde 1994. Casado e pai de duas filhas, acredita que a família é sua principal fonte de inspiração e que valores como ética, responsabilidade e comprometimento devem estar presentes tanto na vida pessoal quanto na profissional.",
            "Com uma sólida trajetória na área contábil, construiu sua carreira atuando nos segmentos contábil, fiscal, trabalhista e societário, assessorando empresas de diferentes portes e ramos de atividade. Ao longo dos anos, desenvolveu experiência em consultoria empresarial, planejamento tributário, abertura, regularização e gestão de empresas, sempre buscando oferecer soluções práticas, seguras e alinhadas às necessidades de cada cliente.",
            "Movido pela busca constante por conhecimento e inovação, atualmente cursa Engenharia de Software, ampliando sua visão sobre tecnologia e transformação digital. Essa formação complementa sua experiência na contabilidade, permitindo integrar soluções tecnológicas à gestão empresarial e acompanhar a evolução do mercado.",
        ],
    },
    {
        name: "Christian Soares Pereira dos Santos",
        role: "Desenvolvimento de Produtos / Sócio",
        image: "integrante3.png",
        paragraphs: [
            "Natural da cidade do Rio de Janeiro, Christian Soares Pereira dos Santos reside em Brasília desde 2020. Compromissado, acredita que valores como persistência, comprometimento e dedicação são fundamentais para construir uma trajetória sólida, tanto na vida pessoal quanto na profissional. Guiado pela convicção de que, com foco e determinação, qualquer objetivo pode ser alcançado, busca transformar desafios em oportunidades de crescimento.",
            "Com atuação voltada ao desenvolvimento de softwares, especialmente no segmento mobile, construiu sua experiência trabalhando com soluções Full Stack para aplicações Mobile, Web, Desktop, APIs e Banco de Dados. Ao longo de sua trajetória, desenvolveu, publicou e realizou a manutenção de sistemas em diferentes plataformas, sempre com atenção à qualidade, à funcionalidade e às necessidades de cada projeto.",
            "Formado em Ciência da Computação pelo IESB no segundo semestre de 2025, mantém uma postura de constante evolução profissional. Sempre em busca de novos desafios e oportunidades de aprendizado, direciona sua atuação para a construção de sistemas seguros, escaláveis e preparados para acompanhar as demandas de um mercado cada vez mais tecnológico e dinâmico.",
        ],
    },
    {
        name: "Rafael Pereira Machado",
        role: "Criação e Inovação",
        image: "integrante4.png",
        paragraphs: [
            "Rafael Pereira Machado, 37 anos, nasceu em Luziânia (GO), mas foi em Brasília que construiu sua história e desenvolveu sua paixão pela cidade, onde sempre viveu.",
            "Graduado em Comunicação Social – Publicidade e Propaganda desde 2013 e também em Design Gráfico, Rafael construiu sua trajetória profissional unindo estratégia, criatividade e inovação. Apaixonado por tudo o que envolve comunicação, design e novas ideias, acredita que a criatividade é um dos principais motores para gerar conexões e resultados.",
            "Atualmente, Rafael integra o time de Criação e Inovação da ClikMob, onde atua como representante da área, contribuindo para fortalecer a comunicação entre a empresa e seu público-alvo. Seu trabalho é pautado pelo desenvolvimento de soluções criativas, pela inovação constante e pelo compromisso em construir experiências que aproximem a marca de seus clientes de forma relevante e eficiente.",
        ],
    },
];

export default function QuemSomos() {
    const [isMobile, setIsMobile] = useState(false);
    
    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Estilos desktop originais (mantidos intactos)
    const styles:  { [key: string]: CSSProperties } = {
        container: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: 50,
            justifyContent: 'center',
            gap: 35
        },
        subContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 15,
            justifyContent: 'center',
            alignItems: 'center',
            width: '40%'
        },
        subContainer2: {
            display: 'flex',
            flexDirection: 'column',
            gap: 30,
            justifyContent: 'center',
            alignItems: 'center',
            width: '50%',
            marginTop: -50
        },
        title: {
            fontSize: Font.title2.fontSize,
            fontWeight: Font.title2.fontWeight,
            color: Colors.white,
            textAlign: 'left',
            backgroundColor: Colors.primary,
            borderRadius: 20,
            padding: 45
        },
        legend: {
            fontSize: Font.menu.fontSize,
            color: Colors.white,
            textAlign: 'justify',
            backgroundColor: Colors.primary,
            borderRadius: 20,
            padding: 45
        },
        logo1: {
            width: '60%',
            aspectRatio: '3 / 2',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 15,
            overflow: 'hidden',
            backgroundColor: Colors.white, // Fundo fixo
        },
        logo: {
            width: '100%',
            aspectRatio: '1 / 1',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 15,
            overflow: 'hidden',
            backgroundColor: Colors.white, // Fundo fixo
        },
        logoImage: {
            width: '100%',
            height: '100%',
            display: 'block',
            objectFit: 'contain',
            objectPosition: 'center',
        },
        subTitle: {
            fontSize: Font.title2.fontSize-10,
            fontWeight: Font.title2.fontWeight,
            color: Colors.primary,
            textAlign: 'center',
            margin: 60,
            marginTop: 10
        },
        imageContainer: {
            position: 'relative',
            width: '100%',
            height: '100%',
            backgroundColor: Colors.white,
            display: 'flex',   
            justifyContent: 'center',
            alignItems: 'center'
        },
        teamGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
            gap: 35,
            maxWidth: 1200,
            margin: '0 auto',
            padding: '0 50px 70px',
        },
        teamCard: {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            backgroundColor: Colors.white,
            border: `1px solid ${Colors.gray}`,
            borderRadius: 20,
            boxShadow: '0 12px 32px rgba(17, 59, 84, 0.12)',
        },
        memberTitle: {
            minHeight: 110,
            margin: 0,
            padding: '24px 28px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: 8,
            color: Colors.white,
            backgroundColor: Colors.primary,
            textAlign: 'center',
            lineHeight: 1.25,
        },
        memberName: {
            display: 'block',
            fontSize: 27,
            fontWeight: Font.title2.fontWeight,
        },
        memberRole: {
            display: 'block',
            fontSize: 18,
            fontWeight: 500,
        },
        memberImageWrapper: {
            width: '100%',
            aspectRatio: '1 / 1',
            overflow: 'hidden',
            backgroundColor: Colors.white,
        },
        memberImage: {
            width: '100%',
            height: '100%',
            display: 'block',
            objectFit: 'contain',
            objectPosition: 'center',
        },
        memberText: {
            display: 'flex',
            flexDirection: 'column',
            gap: 18,
            padding: 30,
            color: Colors.secondaryDark,
            fontSize: 18,
            lineHeight: 1.65,
            textAlign: 'justify',
        },
        memberParagraph: {
            margin: 0,
        }
    }

    // Estilos mobile otimizados
    const mobileStyles: { [key: string]: CSSProperties } = {
        container: {
            display: 'flex',
            flexDirection: 'column',
            padding: '30px 20px',
            gap: 25,
        },
        title: {
            fontSize: Font.title2.fontSize * 0.85,
            fontWeight: Font.title2.fontWeight,
            color: Colors.white,
            textAlign: 'center',
            backgroundColor: Colors.primary,
            borderRadius: 15,
            padding: '25px 20px',
            lineHeight: 1.3,
        },
        legend: {
            fontSize: Font.menu.fontSize * 0.95,
            color: Colors.white,
            textAlign: 'center',
            backgroundColor: Colors.primary,
            borderRadius: 15,
            padding: '25px 20px',
            lineHeight: 1.5,
        },
        imagePlaceholder: {
            width: '100%',
            aspectRatio: '3 / 2',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 15,
            marginTop: 10,
            overflow: 'hidden',
            backgroundColor: Colors.white, // Fundo fixo
        },
        placeholderText: {
            color: Colors.primary,
            fontSize: Font.menu.fontSize,
            opacity: 0.7,
        },
        subTitle: {
            fontSize: (Font.title2.fontSize - 10) * 0.85,
            fontWeight: Font.title2.fontWeight,
            color: Colors.primary,
            textAlign: 'center',
            padding: '30px 20px',
            lineHeight: 1.4,
            backgroundColor: Colors.white,
        },
        teamGrid: {
            display: 'grid',
            gridTemplateColumns: '1fr',
            gap: 28,
            padding: '10px 20px 45px',
            backgroundColor: Colors.white,
        },
        teamCard: {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            backgroundColor: Colors.white,
            border: `1px solid ${Colors.gray}`,
            borderRadius: 15,
            boxShadow: '0 10px 25px rgba(17, 59, 84, 0.12)',
        },
        memberTitle: {
            margin: 0,
            padding: '20px 18px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: 7,
            color: Colors.white,
            backgroundColor: Colors.primary,
            textAlign: 'center',
            lineHeight: 1.25,
        },
        memberName: {
            display: 'block',
            fontSize: 23,
            fontWeight: Font.title2.fontWeight,
        },
        memberRole: {
            display: 'block',
            fontSize: 16,
            fontWeight: 500,
        },
        memberImageWrapper: {
            width: '100%',
            aspectRatio: '1 / 1',
            overflow: 'hidden',
            backgroundColor: Colors.white,
        },
        memberImage: {
            width: '100%',
            height: '100%',
            display: 'block',
            objectFit: 'contain',
            objectPosition: 'center',
        },
        memberText: {
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
            padding: '24px 20px 28px',
            color: Colors.secondaryDark,
            fontSize: 16,
            lineHeight: 1.65,
            textAlign: 'left',
        },
        memberParagraph: {
            margin: 0,
        },
        imageWrapper: {
            width: '100%',
            height: '100%',
            position: 'relative',
            backgroundColor: Colors.white, // Fundo fixo adicional
        },
    };

    if (isMobile) {
        return (
            <Screen>
                <div style={mobileStyles.container}>
                    <div style={mobileStyles.title}>
                        Pessoas que acreditam em pessoas.
                    </div>
                    <div style={mobileStyles.legend}>
                        O ClikMob é desenvolvido por um grupo de profissionais que acreditam que tecnologia e empatia podem caminhar lado a lado. Nosso compromisso é com o respeito, a valorização do trabalho e a construção de um serviço de mobilidade mais humano e acessível.
                    </div>
                    
                    <div style={mobileStyles.imagePlaceholder}>
                        <div style={mobileStyles.imageWrapper}>
                            {/* Imagem principal */}
                            <img 
                                src={IMAGE_PATHS.mainImage} 
                                alt="Equipe ClikMob" 
                                style={mobileStyles.memberImage} 
                                onError={(e) => {
                                    // Fallback para placeholder se a imagem não carregar
                                    const target = e.target as HTMLImageElement;
                                    target.style.display = 'none';
                                }}
                            />
                            <div style={mobileStyles.placeholderText}>
                                {IMAGE_PATHS.mainImage ? '' : 'Imagem da equipe'}
                            </div>
                        </div>
                    </div>
                </div>
                
                <div style={mobileStyles.subTitle}>
                    Estamos unindo inovação, responsabilidade e propósito para transformar o jeito de se mover — e queremos que você venha com a gente.
                </div>
                
                <div style={mobileStyles.teamGrid}>
                    {TEAM_MEMBERS.map((member) => (
                        <article key={member.name} style={mobileStyles.teamCard}>
                            <h2 style={mobileStyles.memberTitle}>
                                <span style={mobileStyles.memberName}>{member.name}</span>
                                <span style={mobileStyles.memberRole}>{member.role}</span>
                            </h2>
                            <div style={mobileStyles.memberImageWrapper}>
                                <img
                                    src={member.image}
                                    alt={member.name}
                                    style={mobileStyles.memberImage}
                                    onError={(e) => {
                                        const target = e.target as HTMLImageElement;
                                        target.style.display = 'none';
                                    }}
                                />
                            </div>
                            <div style={mobileStyles.memberText}>
                                {member.paragraphs.map((paragraph) => (
                                    <p key={paragraph} style={mobileStyles.memberParagraph}>
                                        {paragraph}
                                    </p>
                                ))}
                            </div>
                        </article>
                    ))}
                </div>
                
                <Footer
                    color={Colors.white}
                    backgroundColor={Colors.primary}
                    image="/LOGO%20TM%203.svg"
                />
            </Screen>
        );
    }

    // Return original (desktop)
    return (
        <Screen>
            <div style={styles.container}>
                <div style={styles.subContainer}>
                    <div style={styles.title}>
                        Pessoas que acreditam em pessoas.
                    </div>
                    <div style={styles.legend}>
                        O ClikMob é desenvolvido por um grupo de profissionais que acreditam que tecnologia e  empatia podem caminhar lado a lado.  Nosso compromisso é com o respeito, a valorização do trabalho e a construção de um serviço  de mobilidade mais humano e acessível.
                    </div>
                </div>
                <div style={styles.logo1}>
                    <div style={styles.imageContainer}>
                        <img 
                            src={IMAGE_PATHS.mainImage} 
                            alt="Equipe ClikMob" 
                            style={styles.logoImage} 
                            onError={(e) => {
                                const target = e.target as HTMLImageElement;
                                target.style.display = 'none';
                            }}
                        />
                    </div>
                </div>
            </div>
            <div style={styles.subTitle}>
                Estamos unindo inovação, responsabilidade e propósito para transformar o jeito de se mover  — e queremos que você venha com a gente.
            </div>
            <div style={styles.teamGrid}>
                {TEAM_MEMBERS.map((member) => (
                    <article key={member.name} style={styles.teamCard}>
                        <h2 style={styles.memberTitle}>
                            <span style={styles.memberName}>{member.name}</span>
                            <span style={styles.memberRole}>{member.role}</span>
                        </h2>
                        <div style={styles.memberImageWrapper}>
                            <img
                                src={member.image}
                                alt={member.name}
                                style={styles.memberImage}
                                onError={(e) => {
                                    const target = e.target as HTMLImageElement;
                                    target.style.display = 'none';
                                }}
                            />
                        </div>
                        <div style={styles.memberText}>
                            {member.paragraphs.map((paragraph) => (
                                <p key={paragraph} style={styles.memberParagraph}>
                                    {paragraph}
                                </p>
                            ))}
                        </div>
                    </article>
                ))}
            </div>
            <Footer
                color={Colors.white}
                backgroundColor={Colors.primary}
                image="/LOGO%20TM%203.svg"
            />
        </Screen>
    );
}
